export default __webpack_public_path__ + "media/images/icons/file-alt-solid-ee9e5b2f932264598eca2a2990e812ab.svg";